

























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {QuestionBase} from "@/utilities/question-base";
import Form from "@/components/form.vue";
import moment from "moment";
import Cta from "@/components/cta.vue";
import {deleteCookie, openCheckout, setCookie, toDecimal} from "@/utilities/utilities";
import {State} from "vuex-class";
import Loader from "@/components/loader.vue";

@Component({
    components: {Loader, Cta, Form},
}) export default class extends Vue {
    replace: false;
    @State('ticketTypesList') ticketTypesList;
    @State('cart') cart;
    @State('selector') selector;
    @State('dateAvailability') dateAvailability;
    @State('slotAvailability') slotAvailability;
    @State('typeAvailability') typeAvailability;
    @State('reservationId') reservationId;
    @State('search') search;
    @Prop() data;
    @Prop() debug;
    currencySymbol = '€';
    slots = [];
    slot = null;
    date = moment();
    availability = null;
    questions = [];
    frequency:any = '';
    ticketTypes = [];

    async beforeMount() {
        if (this.data) {
            this.onDataChange();
        } else if (this.selector) {
            this.onSelectorChange();
        }
    }

    get momentDateAvailability() {
        if (this.data) return this.data.dateAvailability.map((date) => moment(date));

        return this.dateAvailability.map((date) => moment(date));
    }

    get normalizedSlotAvailability() {
        if (this.data) {
            return this.data.slotAvailability.Availability.map(this.getNormalizedSlot.bind(this)).map(this.getOption.bind(this));
        }

        console.log(this.slotAvailability);

        if(!this.slotAvailability.Availability) {
            return [{From_datetime_slot: this.selector.From_date_time,
                To_datetime_slot: this.selector.To_date_time }].map(this.getNormalizedSlot.bind(this)).map(this.getOption.bind(this));
        }

        return this.slotAvailability.Availability.map(this.getNormalizedSlot.bind(this)).map(this.getOption.bind(this));
    }

    @Watch('data')
    async onDataChange() {
        this.date = this.data.date;
        this.frequency = this.data.frequency & 35;
        this.ticketTypes = this.data.ticketTypes;
    }


    @Watch('selector') onSelectorChange() {
        this.frequency = this.selector.Frequency & 35;
        this.currencySymbol = this.cart.CurrencySymbol;
        this.ticketTypes = this.selector.TicketTypeList;
    }

    @Watch('ticketTypes')
    async onTicketTypesChange() {
        this.questions = [];

        if (this.frequency === 2 || this.frequency === 0) {
            let dates = this.getEventDates();

            this.questions.push(
                new QuestionBase({
                    key: 'dates',
                    icon: 'l2t-icon-calendar',
                    config: {
                        dates: dates
                    },
                    value: this.frequency === 0 ? `${dates.start.format('MMMM D, YYYY')}` :`${dates.start.format('MMMM D, YYYY')} - ${dates.end.format('MMMM D, YYYY')}`
                }),
                new QuestionBase({
                    key: 'time',
                    icon: 'l2t-icon-clock',
                    config: {
                        dates: dates
                    },
                    value: `${dates.start.format('HH:mm')} - ${dates.end.format('HH:mm')}`
                })
            )
        }

        if (this.frequency === 33 || this.frequency === 1) {
            let value = this.momentDateAvailability[0].isSame('day', this.date) ? this.date : this.momentDateAvailability[0];

            this.questions.push(
                new QuestionBase({
                    controlType: 'date',
                    key: 'dateRange',
                    value: value,
                    icon: 'l2t-icon-calendar',
                    config: {
                        availability: this.momentDateAvailability,
                        range: false,
                        duo: false,
                        date: this.date
                    },
                    events: {
                        change: this.onDateChange.bind(this)
                    }
                })
            );


            this.onDateChange(null, value);
        }

        if (this.frequency === 33) {
            let normalizedSlotAvailability = this.normalizedSlotAvailability;

            this.questions.push(
                new QuestionBase({
                    controlType: 'select',
                    key: 'slot',
                    icon: 'l2t-icon-clock',
                    options: normalizedSlotAvailability,
                    value: normalizedSlotAvailability[0] || null,
                    events: {
                        change: this.onSlotQuestionChange.bind(this)
                    }
                })
            );
        }

        this.questions.push(...this.ticketTypes.map(this.getCounterQuestion.bind(this)));

        if(this.frequency !== 2) {
            this.setCounterMax(this.typeAvailability.TicketTypes);
        }

    }


    getEventDates() {
        let availability = this.normalizedSlotAvailability[0];

        return {start: availability.value.from, end: availability.value.to}
    }


    async onDateChange(e?, model?, resetQuantity?) {
        this.$eventEmitter.emit('setLoaderActive', true);
        let _model = moment(model || new Date()),
            format = _model.format('YYYY-M-DDTHH:mm:ss'),
            slotAvailability = await this.$api.get('availability', {
                From_date_time: format,
                To_date_time: format,
                Event_id: this.data ? this.data.eventId : null
            });


        this.$store.commit('set', {
            key: 'slotAvailability',
            value: slotAvailability
        });




        if (this.frequency === 33) {
            if(!this.slotAvailability.Availability.length) return this.$eventEmitter.emit('setLoaderActive', false);

            this.slots = this.slotAvailability.Availability.map(this.getNormalizedSlot.bind(this)).map(this.getOption.bind(this));

            let slotQuestion = this.questions.find(question => question.key === 'slot');

            slotQuestion.options = this.slots;

            slotQuestion.value = this.slots[0];


            this.setSlot(slotQuestion.value);
        } else {
            let {TicketTypes} = await this.$api.get('typeavailability', {
                From_date_time: format,
                To_date_time: format,
                eventId: this.data ? this.data.eventId : null
            });

            this.setCounterMax(TicketTypes);
        }

        this.$eventEmitter.emit('setLoaderActive', false);
    }


    setCounterMax(typeAvailability) {
        this.questions = this.questions.map(question => {
            let availability = typeAvailability.find(item => item.TicketType_id === question.config.id);

            if(availability) {
                question.config.max = question.config.initialMax = availability.Available;

                if (question.value > question.config.max)
                    this.resetQuantity();
            }

            return question;
        });
    }

    onSlotQuestionChange(e, model) {
        this.slot = model;
    }

    setSlot(val) {
        this.slot = val;
    }

    getSlots(values) {
        if (values.slot) {
            return {
                From_datetime_slot: values.slot.value.from.format('YYYY-M-DDTHH:mm:ss'),
                To_datetime_slot: values.slot.value.to.format('YYYY-M-DDTHH:mm:ss')
            };
        } else if (values.dates || values.dateRange) {
            return {
                From_datetime_slot: this.normalizedSlotAvailability[0].value.from.format('YYYY-M-DDTHH:mm:ss'),
                To_datetime_slot: this.normalizedSlotAvailability[0].value.to.format('YYYY-M-DDTHH:mm:ss')
            };
        }
    }

    async submit() {
        this.$eventEmitter.emit('setLoaderActive', true);


        let form: any = this.$refs.form,
            values = form.submit();

        if (values) {
            let tickets = Object.keys(values).filter(key => key.includes('ticket-') && values[key]).map(key =>
                    Object.assign({TicketType_id: key.replace('ticket-', ''), Quantity: values[key]})
                ),
                body = {},
                response;

            if(!tickets.filter(ticket => ticket.Quantity).length) {
                return this.$eventEmitter.emit('setLoaderActive', false);
            }


            if(this.reservationId) {
                body['Reservation_id'] = this.reservationId;
            }

            if (this.data) {
                let cart = Object.assign({}, this.cart);


                cart.CartEntries = cart.CartEntries.filter(entry => !this.isSameEvent(this.data, entry));

                cart.CartEntries.push(...tickets.map(ticket => {
                    return Object.assign({}, ticket, this.getSlots(values));
                }));


                response = await this.$api.post('updatecart', Object.assign({}, body, {
                    Cart: cart,
                    Reservation_id: this.reservationId
                })).catch(alert);

                if (response) {
                    this.$store.dispatch('setCart', response.Cart);
                    this.$eventEmitter.emit('closePopup');
                }
            } else {
                if(!this.selector.has_Cart) {
                    body['Reservation_id'] = null;
                    deleteCookie('reservationId');
                }

                response = await this.$api.post('reservetickets', Object.assign({Tickets: tickets}, body, this.getSlots(values))).catch(alert);

                if (response) {

                    this.$store.dispatch('setReservationId', response.Reservation_id);
                    setCookie('reservationId', response.Reservation_id, 7);

                    this.$store.dispatch('set', {key: 'cart', value: response.Cart});
                    // this.resetQuantity();

                    if(this.selector.has_Cart) {
                        this.$eventEmitter.emit('setCartActive', true);
                    } else {
                        if(!this.selector.checkout_URL.length) {
                            openCheckout();
                        } else {
                            window.open(`${this.selector.checkout_URL}?reservationId=${this.reservationId}`, "_self");
                        }
                    }
                }
            }
        }

        this.$eventEmitter.emit('setLoaderActive', false);
    }

    @Watch('slot') async onSlotChange() {
        let {TicketTypes} = await this.$api.get('typeavailability', {
            From_date_time: this.slot.value.to.format('YYYY-M-DDTHH:mm:ss'),
            To_date_time: this.slot.value.to.format('YYYY-M-DDTHH:mm:ss'),
            Event_id: this.data ? this.data.eventId : null
        });

        if (this.totalTickets > this.slot.count)
            this.resetQuantity();

        this.setCounterMax(TicketTypes);
    }

    isSameEvent(arrItem, item) {
        let isSameEvent = arrItem.eventName === item.Event_name;
        return !item.From_datetime_slot && isSameEvent || item.From_datetime_slot && moment(item.From_datetime_slot).isSame(arrItem.date) && isSameEvent;
    }

    getCounterQuestion(obj) {
        return new QuestionBase({
            controlType: 'counter',
            type: 'number',
            icon: 'l2t-icon-user',
            config: {
                text: this.getTicketText(obj),
                price: this.getPrice(obj),
                type: obj.Type,
                id: obj.TicketType_id,
                min: obj.MinOrder,
                max: this.frequency === 2 ? 9999 : obj.Available,
                initialMax: this.frequency === 2 ? 9999 : obj.Available
            },
            error: `The minimum is ${obj.MinOrder}`,
            validator: (value, question) => value === 0 || value >= question.config.min,
            value: this.getCounterValue(obj) || 0,
            key: `ticket-${obj.TicketType_id}`,
            events: {
                change: this.onQuantityChange.bind(this)
            }
        })
    }

    getCounterValue(ticketType) {
        if (!this.data) return false;

        let ticket = this.data.tickets.find((ticket) => ticket.id === ticketType.TicketType_id);


        if (!ticket) return 0;

        return ticket.quantity;
    }

    getPrice(obj) {
        let discount = '',
            description = '';

        if (obj.OriginalPrice > obj.Price) {

            discount = `<span class="original-price text-color">${this.currencySymbol}${toDecimal(obj.OriginalPrice)}</span> `;
            description = `<span class="description bg-color-secondary">${this.currencySymbol}${toDecimal(obj.OriginalPrice - obj.Price)} discount</span>`;
        }

        return `<span>${discount}<span class="text-color">${this.currencySymbol}${toDecimal(obj.Price)}</span>${description}</span>`
    }

    getTicketText(obj) {
        let description = '';

        if (obj.Subtitle) {
            description = `<span class="description bg-color-primary">${obj.Subtitle}</span>`;
        }
        return `<span class="text-color">${description}${obj.Name}</span>`;
    }

    onQuantityChange() {
        this.questions.filter(question => question.config.type === 0).forEach(question => {
            question.config.max = this.slot && this.totalTickets === this.slot.value.count ? question.value : question.config.initialMax;
        });
    }

    get totalTickets() {
        return this.questions
            .slice(0)
            .filter(question => question.config.type === 0)
            .reduce((val, item) => val + item.value, 0);
    }

    getOption(slot) {
        return {value: slot, text: slot.from.format('HH:mm') + (this.slotAvailability.show_Availability || slot.count < 10 ? ` (${slot.count} left)` : '')};
    }

    getNormalizedSlot(obj) {
        return {
            from: moment(obj.From_datetime_slot),
            to: moment(obj.To_datetime_slot || obj.From_datetime_slot),
            count: obj.Count || 9999
        };
    }

    resetQuantity() {
        this.questions.filter(question => question.key.includes('ticket-')).forEach(question => {
            question.value = 0
        });
    }
}
